@use 'sass:math';
@use '@dixa/lib-shared-tokens/scss' as *;

$labelHeight: 16px;
$labelHalfHeight: math.div($labelHeight, 2);
$marginTopBottom: var(--dixa-size-spacer-300);

.root {
  position: relative;
  display: block;
  height: 1px;
  margin: $marginTopBottom 0;
  width: 100%;
  background-color: var(--dixa-color-neutral-300);
  line-height: var(--dixa-size-spacer-300);

  &HasLabel {
    margin: calc(#{$labelHalfHeight} - 1px + #{$marginTopBottom}) 0
      calc(#{$labelHalfHeight} + #{$marginTopBottom});
  }
}

.label {
  position: absolute;
  top: 1px;
  left: 0;
  transform: translateY(-50%);
  display: inline-block;
  height: $labelHeight;
  line-height: 15px;
  padding: 0 8px;
  border-radius: 4px;
  background-color: var(--dixa-color-neutral-600);
  color: var(--dixa-color-neutral-000);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
}
